import { GatsbyImage } from 'gatsby-plugin-image';
import get from 'lodash.get';
import PropTypes from 'prop-types';
import React from 'react';

import HeadingCtas from '../Generic/HeadingCtas';
import * as styles from './OverlappingHero.module.css';
import RichTextConverter from './RichText/RichTextConverter';

const OverlappingHero = ({ heading, copy, image, headingCtas = [], className = '', slim = false }) => {
  const imageData = get(image, 'gatsbyImageData');
  const img = get(image, 'file.url');
  const imageComponent = !!imageData ? (
    <GatsbyImage
      data-ot-ignore
      image={imageData}
      className={styles.fluidHero}
      style={{ height: '100%' }}
      alt={image.title || ''}
    />
  ) : (
    <img src={img} alt={image.title || ''} />
  );

  return (
    <div className={styles.hero}>
      <div className={styles.heroContent}>
        <h1>{heading}</h1>
        {copy && (
          <p>
            <RichTextConverter copy={copy} />{' '}
          </p>
        )}
        {headingCtas.length > 0 && <HeadingCtas className={styles.heroCta} ctas={headingCtas} />}
        {/* {cta && onCta && <ArrowLink label={cta} isArrowDown={true} onClick={onCta} />}
        {cta && !onCta && ctaUrl && <ArrowLink label={cta} isArrowDown={false} url={ctaUrl} />} */}
      </div>
      <div className={[styles.heroImageContainer, className].join(' ')}>{imageComponent}</div>
    </div>
  );
};

OverlappingHero.propTypes = {
  heading: PropTypes.string.isRequired,
  paragraphRawJson: PropTypes.object,
  image: PropTypes.object.isRequired,
};

export default OverlappingHero;
